import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  flex: {
    display: 'flex',
  },
  title: {
    marginBottom: 0,
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
  },
  saveBtn: {
    marginLeft: 20,
    background: theme.custom.accept,
  },
  directionColumn: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'calc(50% - 10px)',
    flexBasis: 'calc(50% - 10px)',
    marginRight: 10,
    '&:last-child': {
      maxWidth: '50%',
      flexBasis: '50%',
      marginRight: 0,
    },
  },
  checkboxColumn: {
    display: 'flex',
    alignItems: 'center',
  },
  checkboxLabel: {
    display: 'block',
    marginLeft: 15,
    fontSize: 16,
    color: theme.custom.darkBlue,
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
  box: {
    flex: 1,
  },
  label: {
    display: 'block',
    marginBottom: 5,
    fontSize: 16,
    fontFamily: 'NeoSansStd',
    color: '#646464',
    '& sup': {
      fontSize: 16,
      fontWeight: 700,
      color: theme.custom.warning,
    },
  },
  mb0: {
    marginBottom: 0,
  },
  text: {
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  titledBox: {
    '& > div': {
      marginBottom: 20,
    },
  },
  p15: {
    padding: 15,
  },
  mt20: {
    marginTop: 20,
  },
  mb20: {
    marginBottom: 20,
  },
  pl20: {
    paddingLeft: 20,
  },
  pl35: {
    paddingLeft: 35,
  },
  input: {
    paddingRight: 7,
    fontSize: 16,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  socialSecurityTip: {
    fontSize: 13,
    opacity: 0.5,
  },
  inputBorder: {
    width: '100%',
    borderBottom: '1px solid rgba(34, 64, 96, .2)',
  },
  paper: {
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    borderRadius: 0,
  },
  bankGrid: {
    display: 'flex',
    flexDirection: 'column',
  },
  bankGridRow: {
    display: 'flex',
  },
  bankGridItem: {
    display: 'flex',
    marginRight: 15,
    '&:first-child': {
      width: '48%',
    },
    '&:nth-child(2)': {
      justifyContent: 'center',
      width: '21%',
    },
    '&:nth-child(3)': {
      justifyContent: 'center',
      width: '21%',
      marginRight: 0,
    },
  },
  bankGridItemText: {
    fontSize: 15,
    color: '#646464',
  },
  addBankAccountBtn: {
    background: theme.custom.lightBlue,
  },
  mt10: {
    marginTop: 10,
  },
  deleteBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
    padding: 3,
    minWidth: 'auto',
    background: theme.custom.warning,
    borderRadius: 2,
  },
  deleteIcon: {
    fontSize: '1.4rem',
    color: '#fff',
  },
  alignStart: {
    alignItems: 'flex-start',
  },
  formControl: {
    display: 'block',
    marginBottom: 15,
  },
  radioGroup: {
    display: 'inline-flex',
  },
  formLabel: {
    display: 'block',
    marginBottom: 5,
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    letterSpacing: 'normal',
    lineHeight: 'auto',
    color: '#646464',
    '&.Mui-focused': {
      color: '#646464',
    },
  },
  formControlLabelRoot: {
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 5,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  formControlLabel: {
    marginLeft: 10,
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    color: '#646464',
  },
  radioTitle: {
    marginBottom: 15,
  },
  ml10: {
    marginLeft: 10,
  },
  loaderRoot: {
    display: 'block',
  },
  datePicker: {
    padding: 4,
    paddingLeft: 0,
    background: 'transparent',
    borderBottom: '1px solid rgba(34, 64, 96, .2)',
  },
  datePickerError: {
    borderColor: theme.custom.warning,
  },
  datePickerText: {
    color: '#224060',
  },
  tooltipIcon: {
    marginLeft: 7,
    fontSize: '1.1rem',
    color: '#646464',
    cursor: 'pointer',
  },
  tooltip: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
  },
  mb5: {
    marginBottom: 5,
  },
  modifiedBox: {
    display: 'block',
  },
}));
